import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetProduct, getLinhas, getMarcas } from '../../../slices/productSlice';

import CategoriasLinhas from '../../../components/CategoriasLinhas/CategoriasLinhas';
import Listar from '../../../components/Listas/Listar';
import Main from '../../../components/Main/Main';
import Title from '../../../components/Title.jsx';
import DivSession from '../../../components/Main/DivSession.jsx';
import usePageTitle from '../../../hook/usePageTitle.js';

// document.title = 'Cadastro | Categorias/Marcas';

const Categoria = () => {
  const dispatch = useDispatch();
  const { linhas, marcas } = useSelector((state) => state.product);

  usePageTitle();

  useEffect(() => {
    dispatch(resetProduct());
    dispatch(getLinhas());
    dispatch(getMarcas());
  }, []);

  const handleNew = () => {
    dispatch(getLinhas());
    dispatch(getMarcas());
  };

  return (
    <Main>
      <Title>Central</Title>
      <DivSession>
        <div className="flex flex-col gap-5 sm:flex-wrap sm:flex-row sm:h-[80vh] w-[90%] sm:w-full sm:justify-between md:gap-2 lg:gap-10">
          <CategoriasLinhas title={' Categorias de compras'} />
          <Listar title="Linhas" array={linhas} url={'linha'} news={handleNew} />
          <Listar title="Marcas" array={marcas} url={'marca'} news={handleNew} />
        </div>
      </DivSession>
    </Main>
  );
};

export default Categoria;
